export default function Features() {
  return (
    <section className="relative py-16 sm:py-28 px-4 sm:px-6 overflow-hidden" style={{background: 'linear-gradient(160deg, #111e3a 0%, #0d1f3c 40%, #152a52 100%)'}}>
      <div className="absolute inset-0 opacity-[0.03]" style={{backgroundImage: 'linear-gradient(120deg, transparent 45%, #c9a227 46%, #c9a227 46.4%, transparent 47%), linear-gradient(60deg, transparent 55%, #c9a227 56%, #c9a227 56.3%, transparent 57%)', backgroundSize: '400px 400px'}}></div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-12 sm:mb-20 text-center">
          <h2 className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mb-4 sm:mb-5 leading-[1.2] tracking-tight">
            <span className="text-[#c9a227]">전원주택·산소</span> 모두에 적용되는{' '}
            <span className="text-[#c9a227]">첨단 기술</span>
          </h2>
          <p className="text-base sm:text-xl text-white/70 font-medium leading-relaxed">
            두 사업 축을 관통하는 디지털 기반 관리 시스템
          </p>
        </div>

        <div className="flex flex-col md:grid md:grid-cols-2 gap-5 sm:gap-7 mb-10 sm:mb-16">
          {/* Left Large Card */}
          <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-lg border border-[#c9a227]/20 transition-all duration-300 hover:shadow-2xl hover:-translate-y-2" style={{ minHeight: '340px', height: '100%', background: 'linear-gradient(135deg, #1e3a6e, #0d1f3c)' }}>
            <div className="absolute top-5 sm:top-7 left-5 sm:left-7 z-20">
              <span className="inline-block bg-[#c9a227]/20 backdrop-blur-sm text-[#c9a227] px-3 sm:px-4 py-1.5 sm:py-2 rounded-full text-xs sm:text-sm font-medium tracking-wide border border-[#c9a227]/30">
                위성 분석 기술
              </span>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <img
                src="https://public.readdy.ai/ai/img_res/f8007ca51aa8de1e8d9b8c4f9f0b2fe6.jpg"
                alt="10년치 위성 사진 분석"
                className="w-full h-full object-cover opacity-60"
              />
            </div>
            <div className="absolute bottom-6 sm:bottom-8 left-5 sm:left-7 right-5 sm:right-7 z-20">
              <h3 className="text-white text-2xl sm:text-3xl font-bold mb-2 sm:mb-3 leading-snug tracking-tight">
                10년 지형 변화 추적
              </h3>
              <p className="text-white/75 text-sm sm:text-base leading-relaxed">
                전원주택 부지와 선산 모두 위성 데이터로 정밀 분석
              </p>
            </div>
          </div>

          {/* Right Column - 3 Cards */}
          <div className="flex flex-col gap-5 sm:gap-7">
            {/* 전원주택 정원 드론 카드 */}
            <div className="rounded-2xl shadow-sm border border-[#c9a227]/15 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden flex flex-row" style={{ minHeight: '140px', background: 'linear-gradient(135deg, #152a52, #0d1f3c)' }}>
              <div className="w-[150px] sm:w-[170px] flex-shrink-0 p-5 sm:p-6 flex flex-col justify-center gap-2">
                <div className="flex items-start gap-2">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-drone-line text-lg sm:text-xl text-[#c9a227]"></i>
                  </div>
                  <div>
                    <span className="inline-block w-fit bg-[#c9a227]/15 px-2 py-0.5 rounded-full text-xs font-semibold text-[#c9a227] border border-[#c9a227]/30 mb-1.5">
                      전원주택 정원
                    </span>
                    <h3 className="text-xs sm:text-sm font-bold text-white mb-1.5 leading-snug tracking-tight">
                      정원 드론 촬영 보고
                    </h3>
                    <p className="text-xs text-white/55 leading-[1.7] hidden sm:block">
                      작업 전후 고화질 드론 촬영으로<br />정원 관리 결과를 투명하게 확인
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex items-center justify-center overflow-hidden py-2 pr-2">
                <div className="w-[90%] h-[90%] overflow-hidden rounded-xl">
                  <img
                    src="https://static.readdy.ai/image/b6088df85b1af9036dd560688f3d7991/85d77db49f9b1250c299decf1907a770.jpeg"
                    alt="전원주택 정원 드론 촬영"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>

            {/* 산소 벌초 드론 카드 */}
            <div className="rounded-2xl shadow-sm border border-[#c9a227]/15 transition-all duration-300 hover:shadow-lg hover:-translate-y-1 overflow-hidden flex flex-row" style={{ minHeight: '140px', background: 'linear-gradient(135deg, #152a52, #0d1f3c)' }}>
              <div className="w-[150px] sm:w-[170px] flex-shrink-0 p-5 sm:p-6 flex flex-col justify-center gap-2">
                <div className="flex items-start gap-2">
                  <div className="w-7 h-7 sm:w-8 sm:h-8 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <i className="ri-drone-line text-lg sm:text-xl text-[#c9a227]"></i>
                  </div>
                  <div>
                    <span className="inline-block w-fit bg-[#c9a227]/15 px-2 py-0.5 rounded-full text-xs font-semibold text-[#c9a227] border border-[#c9a227]/30 mb-1.5">
                      산소 벌초
                    </span>
                    <h3 className="text-xs sm:text-sm font-bold text-white mb-1.5 leading-snug tracking-tight">
                      선산 드론 촬영 보고
                    </h3>
                    <p className="text-xs text-white/55 leading-[1.7] hidden sm:block">
                      벌초 전후 드론 촬영으로<br />선산 관리 상태를 명확하게 기록
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex-1 flex items-center justify-center overflow-hidden py-2 pr-2">
                <div className="w-[90%] h-[90%] overflow-hidden rounded-xl">
                  <img
                    src="https://static.readdy.ai/image/b6088df85b1af9036dd560688f3d7991/168285117254094760afc575cad060d9.jpeg"
                    alt="산소 선산 드론 촬영"
                    className="w-full h-full object-cover object-center"
                  />
                </div>
              </div>
            </div>

            {/* 정밀 면적 측정 카드 */}
            <div className="relative rounded-2xl overflow-hidden shadow-sm border border-[#c9a227]/15 transition-all duration-300 hover:shadow-lg hover:-translate-y-1" style={{ minHeight: '140px' }}>
              <img
                src="https://static.readdy.ai/image/b6088df85b1af9036dd560688f3d7991/36711f6ef667fa7b005fd62235bac67a.jpeg"
                alt="정밀 면적 측정 위성 사진"
                className="absolute inset-0 w-full h-full object-cover object-center"
              />
              <div className="absolute inset-0 bg-[#0d1f3c]/65"></div>
              <div className="relative z-10 p-5 sm:p-7 flex items-start gap-4 h-full">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-3xl sm:text-4xl text-[#c9a227]"></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg sm:text-xl font-bold text-white mb-2 tracking-tight">
                    정밀 면적 측정
                  </h3>
                  <p className="text-xs sm:text-sm text-white/75 mb-3 leading-[1.75]">
                    GPS 기반 정확한 면적 산출로 투명한 견적 제시
                  </p>
                  <span className="inline-block bg-[#c9a227]/20 backdrop-blur-sm px-3 py-1 rounded-full text-xs sm:text-sm font-medium text-[#c9a227] border border-[#c9a227]/30">
                    ±3% 오차 범위
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
